import { render, staticRenderFns } from "./ModalTeachingMemo.vue?vue&type=template&id=22a0b5d8&scoped=true&lang=pug&"
import script from "./ModalTeachingMemo.vue?vue&type=script&lang=ts&"
export * from "./ModalTeachingMemo.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTeachingMemo.vue?vue&type=style&index=0&id=22a0b5d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a0b5d8",
  null
  
)

export default component.exports